import React from "react";

// Import Components
import PokemonInfo from "./PokemonInfo";

// Import assets
import "./pokedex.css";

export default function PokeDex(props) {
  return (
    <div id="pokedex">
      <div id="left">
        <div id="logo"></div>
        <div id="bg_curve1_left"></div>
        <div id="bg_curve2_left"></div>
        <div id="curve1_left">
          <div id="buttonGlass">
            <div id="reflect"> </div>
          </div>
          <div id="miniButtonGlass1"></div>
          <div id="miniButtonGlass2"></div>
          <div id="miniButtonGlass3"></div>
        </div>
        <div id="curve2_left">
          <div id="junction">
            <div id="junction1"></div>
            <div id="junction2"></div>
          </div>
        </div>
        <div id="screen">
          <div id="topPicture">
            <div id="buttontopPicture1"></div>
            <div id="buttontopPicture2"></div>
          </div>
          <div id="picture">
            {props.selectedPokemon !== null && (
              <img
                src={
                  props.selectedPokemon.sprites.versions["generation-v"]["black-white"].animated.front_default
                }
                alt="psykokwak"
                height="170"
              />
            )}
          </div>
          <div id="buttonbottomPicture"></div>
          <div id="speakers">
            <div className="sp"></div>
            <div className="sp"></div>
            <div className="sp"></div>
            <div className="sp"></div>
          </div>
        </div>
        <div id="bigbluebutton">
          <button className="pokedex-close" onClick={props.closePokedex}>
            X
          </button>
        </div>
        <div id="barbutton1"></div>
        <div id="barbutton2"></div>
        <div id="cross">
          <div id="leftcross">
            <div id="leftT"></div>
          </div>
          <div id="topcross">
            <div id="upT"></div>
          </div>
          <div id="rightcross">
            <div id="rightT"></div>
          </div>
          <div id="midcross">
            <div id="midCircle"></div>
          </div>
          <div id="botcross">
            <div id="downT"></div>
          </div>
        </div>
      </div>
      <div id="right">
        <div id="stats">{props.selectedPokemon !== null && <PokemonInfo info={props.selectedPokemon} />}</div>
        <div id="yellowBox1">
          {props.selectedPokemon !== null && `${props.selectedPokemon.forms[0].name}`}
        </div>
        <div id="yellowBox2">{props.selectedPokemon !== null && `#${props.selectedPokemon.id}`}</div>
        <div id="bg_curve1_right"></div>
        <div id="bg_curve2_right"></div>
        <div id="curve1_right"></div>
        <div id="curve2_right"></div>
      </div>
    </div>
  );
}
